/**
 * PixelInput 컴포넌트
 * 레트로 게임 스타일의 픽셀 입력 필드
 * - 게임보이 LCD 느낌의 입력 박스
 * - 깜빡이는 픽셀 커서
 * - 도트 테두리
 */

import React, { InputHTMLAttributes } from 'react';

/**
 * PixelInput Props
 */
interface PixelInputProps extends InputHTMLAttributes<HTMLInputElement> {
  /**
   * 라벨 (선택사항)
   */
  label?: string;

  /**
   * 에러 메시지 (선택사항)
   */
  error?: string;

  /**
   * 전체 너비 여부
   */
  fullWidth?: boolean;
}

/**
 * PixelInput 컴포넌트
 * 레트로 게임 스타일의 도트 입력 필드
 */
export const PixelInput: React.FC<PixelInputProps> = ({
  label,
  error,
  fullWidth = false,
  className = '',
  ...props
}) => {
  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {/* 라벨 */}
      {label && (
        <label className="block mb-2 font-pixel text-sm text-gray-300">
          {label}
        </label>
      )}

      {/* 입력 필드 */}
      <input
        className={`
          font-pixel
          bg-[#0f380f]
          text-[#9bbc0f]
          px-4
          py-3
          focus:outline-none
          placeholder-[#306230]
          transition-all
          ${fullWidth ? 'w-full' : ''}
          ${error ? 'border-red-500' : ''}
          ${className}
        `}
        style={{
          border: error ? '3px solid #ef4444' : '3px solid #306230',
          boxShadow: error
            ? '0 4px 0 #b91c1c, inset 0 0 10px rgba(239,68,68,0.2)'
            : '0 4px 0 #306230, inset 0 0 10px rgba(15,56,15,0.5)',
          caretColor: '#9bbc0f',
        }}
        {...props}
      />

      {/* 에러 메시지 */}
      {error && (
        <p className="mt-2 font-pixel text-xs text-red-400 flex items-center gap-1">
          <span>⚠</span>
          <span>{error}</span>
        </p>
      )}
    </div>
  );
};
